import { fromType } from "@src/store/helpers";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { snowFlakeBaseUrl } from "@src/store/ApiProvider";
import { RootState } from "@src/store/store";
import { createSelector } from "@reduxjs/toolkit";
import { _selectSelectedSectionNames } from "@src/store/map/mapSlice";
import { useSalesChartData } from "@src/hooks/useChartData";

export type TSoldList = {
	averagePrice: number;
	date: string;
	ticketCount: number;
};

export type ExpandedSoldList = TSoldList & { section: string };

export type TSoldInitialState = {
	eventData: Array<TSoldList>;
	sectionData: Array<ExpandedSoldList>;
};

const initialState = fromType<TSoldInitialState>({
	eventData: [],
	sectionData: [],
});

export const { thunk: getSoldChartsPlus, slice: getSoldChartsPlusSlice } = getThunkAndSlice<
	{
		eventId: number;
	},
	typeof initialState
>({
	initialState,
	externalPath: ({ eventId }) => `${snowFlakeBaseUrl}/sales?eventId=${eventId}`,
	path: ({ eventId }) => `/api/salesChart/${eventId}/data`,
	cacheId: "eventId",
});

const selectSoldChartData = (state: RootState) => state.marketplace.seatgeek.soldCharts;

export const selectAggregatedSoldChartData = createSelector(
	[selectSoldChartData, _selectSelectedSectionNames],
	(soldChart, selectedSections) => {
		return {
			salesChartLoading: soldChart.loading,
			filteredSalesChartData: useSalesChartData({ rawSections: selectedSections, data: soldChart.data }),
		};
	},
);
